import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ParametrosNuevaSolicitudExViewModel, SolicitudExViewModel } from './datosbasicosEx.types';
import { TUsuarioExternoViewModel, TSolicitanteAdministrativoViewModel } from '../../../_importacion/solicitudes/datosbasicos/datosbasicos.types';
import { TClaveSolicitudAtestFitoViewModel } from '../../atestaciones/datosbasicos/datosbasicosAtestFito.types';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class SolicitudExService {
    private paramsKey = 'exportParams';
    public currentParamNuevaSolicitudEx = new ParametrosNuevaSolicitudExViewModel();
    public currentIdSolicitudEx: number;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    // Persist params into localStorage or removes it if a NULL argument is given
    setParamsSolicitudEx(params: ParametrosNuevaSolicitudExViewModel | null): boolean {
        if (params) {
            localStorage.setItem(this.paramsKey, JSON.stringify(params));
        } else {
            localStorage.removeItem(this.paramsKey);
        }
        return true;
    }

    // Retrieves the params JSON object (or NULL if none)
    getParamsSolicitudEx(): ParametrosNuevaSolicitudExViewModel | null {
        let params: ParametrosNuevaSolicitudExViewModel = new ParametrosNuevaSolicitudExViewModel();
        let paramsJSON: ParametrosNuevaSolicitudExViewModel;

        let i = localStorage.getItem(this.paramsKey);
        if (i) {
            paramsJSON = JSON.parse(i);

            //params.esNifExtranjero = paramsJSON.esNifExtranjero;
            params.esPrevia = paramsJSON.esPrevia;
            params.IdPuntoInspeccion = paramsJSON.IdPuntoInspeccion;
            params.IdTipoSolicitudEx = paramsJSON.IdTipoSolicitudEx;
            params.IdSubTipoSolicitudEx = paramsJSON.IdSubTipoSolicitudEx;
            params.tipoSolicitudEx = paramsJSON.tipoSolicitudEx;
            params.IdPaisDestino = paramsJSON.IdPaisDestino;
            params.IdIdioma = paramsJSON.IdIdioma;
            params.IdUbicacion = paramsJSON.IdUbicacion;
            params.IdInstalacionAutorizada = paramsJSON.IdInstalacionAutorizada;
            params.IdCampania = paramsJSON.IdCampania;
            params.IdPeriodo = paramsJSON.IdPeriodo;
            params.AvisoConfeccion = paramsJSON.AvisoConfeccion;
            params.esAtestacionFitosanitaria = paramsJSON.esAtestacionFitosanitaria;
            return params;
        } else {
            return null;
        }
    }

    getSolicitudEx(id: number): Observable<SolicitudExViewModel> {
        return this.http.get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/' + id).pipe();
    }

    asignarSolicitudEx(params: HttpParams): Observable<any> {
        return this.http.get<any>(this.baseUrl + 'api/exportacion/solicitudEx/AsignarSolicitud/', { params: params }).pipe();
    }

    isSolicitudUsuario(params: HttpParams): Observable<boolean> {
        return this.http.get<boolean>(this.baseUrl + 'api/exportacion/main/IsSolicitudExUsuario/', { params: params }).pipe();
    }

    searchAtestacionRefAtestPin(params: HttpParams): Observable<TClaveSolicitudAtestFitoViewModel> {
        return this.http
            .get<TClaveSolicitudAtestFitoViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/SearchAtestacionRefAtestPin/', { params: params })
            .pipe();
    }

    getSolicitudSolo(id: number): Observable<SolicitudExViewModel> {
        return this.http.get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/getsolicitudbyid/' + id).pipe();
    }

    getSolicitudAnulaSustituyeSolicitudPadreByIdPadre(id: number): Observable<SolicitudExViewModel> {
        return this.http.get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/getSolicitudAnulaSustituyeSolicitudPadreByIdPadre/' + id).pipe();
    }

    getEnvioSolicitudInspector(id: number): Observable<SolicitudExViewModel> {
        return this.http.get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/getenviosolicitudinspectorbyid/' + id).pipe();
    }

    //getEnvioSolicitud(id: number): Observable<SolicitudExViewModel> {
    //    return this.http
    //        .get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/getenviosolicitudbyid/' + id).pipe();
    //}

    getSolicitanteAdministrativo(nif: string): Observable<TSolicitanteAdministrativoViewModel> {
        return this.http.get<TSolicitanteAdministrativoViewModel>(this.baseUrl + 'api/importacion/solicitante/grabador/' + nif).pipe();
    }

    getSolicitudPredua(id: number): Observable<SolicitudExViewModel> {
        return this.http.get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/getsolicitudpreduabyid/' + id).pipe();
    }

    getSolicitudExByCodigo(codigo: string): Observable<SolicitudExViewModel> {
        return this.http.get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/getsolicitudexbycodigo/' + codigo).pipe();
    }

    getSolicitudExByNumeroCertificado(numerocertificado: string): Observable<SolicitudExViewModel> {
        return this.http
            .get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/getsolicitudexbynumerocertificado/' + numerocertificado.split('/')[1].trim())
            .pipe();
    }

    checkAnulSustActiva(id: number): Observable<boolean> {
        return this.http.get<boolean>(this.baseUrl + 'api/exportacion/solicitudEx/CheckAnulSustActiva/' + id).pipe();
    }

    /*--------*/

    //getRegistroImportadores(dniCifNie: string): Observable<TImportadorViewModel> {
    //    return this.http
    //        .get<TImportadorViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/registroimportadores/' + dniCifNie).pipe();
    //}

    getSolicitante(id: number): Observable<TUsuarioExternoViewModel> {
        return this.http.get<TUsuarioExternoViewModel>(this.baseUrl + 'api/importacion/solicitante/' + id).pipe();
    }

    //getSolicitanteAdministrativo(nif: string): Observable<TSolicitanteAdministrativoViewModel> {
    //    return this.http
    //        .get<TSolicitanteAdministrativoViewModel>(this.baseUrl + 'api/exportacion/solicitante/grabador/' + nif).pipe();
    //}

    /*--------*/

    createSolicitud(solicitud: SolicitudExViewModel): Observable<any> {
        return this.http.post<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx', solicitud).pipe();
    }

    editSolicitud(solicitud: SolicitudExViewModel): Observable<any> {
        return this.http.put<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx', solicitud).pipe();
    }

    exportDocumentoDatosSolicitud(idSolicitud: number): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/solicitudEx/PostExportPdfDocumentoDatosSolicitud', idSolicitud, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    exportDocumentoResultadoInspeccion(idSolicitud: number): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/solicitudEx/PostExportPdfDocumentoResultadoInspeccion', idSolicitud, {
                observe: 'response',
                responseType: 'blob',
            })
            .pipe();
    }

    exportDocumentoFitoSanitarioTransporte(idSolicitud: number): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/solicitudEx/PostExportPdfDocumentoFitosanitarioTransporte', idSolicitud, {
                observe: 'response',
                responseType: 'blob',
            })
            .pipe();
    }

    //EXPORT CPE
    //exportDocumentoCertificadoPrevioExportacion(idSolicitud: number): Observable<HttpResponse<Blob>> {
    //    return this.http.post(this.baseUrl + 'api/exportacion/solicitudEx/PostExportPdfDocumentoCertificadoPrevioExportacion', idSolicitud, { observe: 'response', responseType: 'blob' })
    //        .pipe();
    //}

    //exportCertificadoFitosanitario(idSolicitud: number): Observable<HttpResponse<Blob>> {

    //    return this.http.post(this.baseUrl + 'api/exportacion/solicitudEx/PostExportPdfCertificadoFitosanitario', idSolicitud, { observe: 'response', responseType: 'blob' })
    //        .pipe();
    //}

    //exportInformeEPhytoTraces(numeroCertificado: string): Observable<HttpResponse<Blob>> {

    //    let request = new GenericPostRequest();

    //    request.Value = numeroCertificado;

    //    return this.http.post(this.baseUrl + 'api/exportacion/solicitudEx/PostExportEphytoPdfTraces', request, { observe: 'response', responseType: 'blob' })
    //        .pipe();
    //}

    //exportCertificadoExportCanarias(certificado: string, pin: number): Observable<HttpResponse<Blob>> {
    //    let cert = new TClaveCertCanariaViewModel();

    //    cert.Certificado = certificado;
    //    cert.Pin = pin;

    //    return this.http.post(this.baseUrl + 'api/exportacion/solicitudEx/PostExportPdfCertificadoCanarias', cert, { observe: 'response', responseType: 'blob' })
    //        .pipe();
    //}
}
